import { MatButtonModule } from '@angular/material/button';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { MatIconModule } from '@angular/material/icon';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { UtilitiesModule } from '@fi-app/utilities/utilities.module';
import { ButtonBackModule } from '@fi-app/utilities/button-back/button-back.module';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatExpansionModule } from '@angular/material/expansion';
import { FiFormEditFormGeneralComponent } from './fi-form-edit-form/fi-form-edit-form-general/fi-form-edit-form-general.component';
import { FiFormEditSettingsComponent } from './fi-form-edit-settings/fi-form-edit-settings.component';
import { FiFormEditLogicComponent } from './fi-form-edit-logic/fi-form-edit-logic.component';
import { FiFormEditFormComponent } from './fi-form-edit-form/fi-form-edit-form.component';
import { FiFormEditComponent } from './fi-form-edit.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FiEditPublicationModule } from '@fi-shared/fi-edit-publication';
import { FiFormTextQuestionComponent } from './fi-form-edit-form/fi-form-text-question/fi-form-text-question.component';
import { FiFormElementsComponent } from './fi-form-elements/fi-form-elements.component';
import { FiChoiceQuestionComponent } from './fi-form-edit-form/fi-form-choice-question/fi-choice-question.component';
import { MatRadioModule } from '@angular/material/radio';
import { FiValidatingFormModule } from '@fi-shared/fi-directives/fi-validating-form/fi-validating-form.module';
import { FiFormAdditionalTextElementComponent } from './fi-form-edit-form/fi-form-additional-text-element/fi-form-additional-text-element.component';
import { FiFormImageElementComponent } from './fi-form-edit-form/fi-form-image-element/fi-form-image-element.component';
import { FiPageCollapsableContentModule } from '@fi-app/components/fi-page-collapsable-content/fi-page-collapsable-content.module';
import { FiAutofocusModule } from '@fi-shared/fi-directives/autofocus/autofocus.module';
import { FiFormSharedModule } from '@fi-shared/fi-form-shared/fi-form-shared.module';
import { FiAutoscrollOnDragModule } from '@fi-shared/fi-directives/fi-autoscroll-on-drag/fi-autoscroll-on-drag.module';
import { FiAttachmentsModule } from '@fi-shared/media-bank/fi-attachments/fi-attachments.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSelectModule } from '@angular/material/select';
import { FiFormAttachmentElementComponent } from './fi-form-edit-form/fi-form-attachment-element/fi-form-attachment-element.component';
import { FiFormEditLogicModule } from '@fi-app/fi-form/fi-form-edit/fi-form-edit-logic/fi-form-edit-logic.module';
import { FiPageHeaderModule } from '@fi-app/components/fi-page-header/fi-page-header.module';
import { FiChoiceQuestionValidateComponent } from './fi-form-edit-form/fi-form-choice-question/fi-choice-question-validate.component';
import { FiFormQuestionMenuComponent } from './fi-form-edit-form/fi-form-question-menu/fi-form-question-menu.component';
import { FiErrorMessageModule } from '@fi-shared/fi-error-message';
import { FiTextEditorSharedModule } from '@fi-shared/fi-text-editor/fi-text-editor-shared.module';
import { FiInsertMediaModule } from '@fi-shared/fi-insert-media/fi-insert-media.module';
import { CdkDrag, CdkDragHandle, CdkDragPlaceholder, CdkDragPreview, CdkDropList } from '@angular/cdk/drag-drop';
import { FormQuestionIconIndexComponent } from '@fi-app/fi-form/fi-form-edit/fi-form-edit-form/form-question-icon-index/form-question-icon-index.component';
import { FiFormQuestionNamesEditorComponent } from '@fi-app/fi-form/fi-form-edit/fi-form-edit-form/form-question-names-editor/form-question-names-editor.component';
import { FiTooltipModule } from '@fi-shared/fi-tooltip/fi-tooltip.module';
import { FiAnswerOptionsDndEditorModule } from '@fi-app/shared/fi-answer-options-dnd-editor/fi-answer-options-dnd-editor.module';
import { FiNameInputModule } from '@fi-app/shared/fi-name-input/fi-name-input.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatTabsModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        FiValidatingFormModule,
        FiAutofocusModule,
        ButtonBackModule,
        UtilitiesModule,
        FiAppTextSharedModule,
        FiEditPublicationModule,
        MatCardModule,
        MatSlideToggleModule,
        MatSelectModule,
        MatMenuModule,
        MatExpansionModule,
        MatRadioModule,
        MatIconModule,
        SelectSearchModule,
        FiPageCollapsableContentModule,
        FiFormSharedModule,
        FiFormEditLogicModule,
        FiAutoscrollOnDragModule,
        FiAttachmentsModule,
        FiPageHeaderModule,
        FiErrorMessageModule,
        FiTextEditorSharedModule,
        FiInsertMediaModule,
        CdkDropList,
        CdkDrag,
        CdkDragHandle,
        CdkDragPlaceholder,
        CdkDragPreview,
        FiTooltipModule,
        FiAnswerOptionsDndEditorModule,
        FiNameInputModule,
    ],
    declarations: [
        FiFormEditComponent,
        FiFormEditFormComponent,
        FiFormEditLogicComponent,
        FiFormEditSettingsComponent,
        FiFormEditFormGeneralComponent,
        FiFormTextQuestionComponent,
        FiFormElementsComponent,
        FiChoiceQuestionComponent,
        FiFormAdditionalTextElementComponent,
        FiFormImageElementComponent,
        FiFormAttachmentElementComponent,
        FiChoiceQuestionValidateComponent,
        FiFormQuestionMenuComponent,
        FormQuestionIconIndexComponent,
        FiFormQuestionNamesEditorComponent,
    ],
})
export class FiFormEditModule {}
